(() => {
  const mobileProductCardQuery = window.matchMedia('(max-width: 989px)');
  const productMediaSelector =
    '.product-card-wrapper a.card__media[href], .fx-catalog-card a.fx-catalog-card__media[href]';
  let activeTouch = null;

  const closestProductMediaLink = (target) => {
    if (!mobileProductCardQuery.matches || !target || typeof target.closest !== 'function') {
      return null;
    }

    return target.closest(productMediaSelector);
  };

  const updateProductCardMode = (root = document) => {
    const mediaElements = root.querySelectorAll(
      '.product-card-wrapper .media--hover-effect, .product-card-wrapper .media--mobile-primary-only'
    );

    mediaElements.forEach((media) => {
      media.classList.toggle('media--hover-effect', !mobileProductCardQuery.matches);
      media.classList.toggle('media--mobile-primary-only', mobileProductCardQuery.matches);
    });
  };

  document.addEventListener(
    'touchstart',
    (event) => {
      if (event.touches.length !== 1) {
        activeTouch = null;
        return;
      }

      const link = closestProductMediaLink(event.target);
      if (!link) {
        activeTouch = null;
        return;
      }

      const touch = event.touches[0];
      activeTouch = {
        link,
        x: touch.clientX,
        y: touch.clientY,
        startedAt: performance.now(),
      };
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!activeTouch || event.touches.length !== 1) return;

      const touch = event.touches[0];
      if (
        Math.abs(touch.clientX - activeTouch.x) > 10 ||
        Math.abs(touch.clientY - activeTouch.y) > 10
      ) {
        activeTouch = null;
      }
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      const completedTouch = activeTouch;
      activeTouch = null;

      if (!completedTouch || event.changedTouches.length !== 1) return;

      const touch = event.changedTouches[0];
      const endingLink = closestProductMediaLink(event.target);
      const stayedOnLink = endingLink === completedTouch.link;
      const stayedInPlace =
        Math.abs(touch.clientX - completedTouch.x) <= 10 &&
        Math.abs(touch.clientY - completedTouch.y) <= 10;
      const wasQuickTap = performance.now() - completedTouch.startedAt <= 700;

      if (!stayedOnLink || !stayedInPlace || !wasQuickTap) return;

      event.preventDefault();
      window.location.assign(completedTouch.link.href);
    },
    { capture: true, passive: false }
  );

  document.addEventListener(
    'touchcancel',
    () => {
      activeTouch = null;
    },
    { capture: true, passive: true }
  );

  const initializeProductCards = () => updateProductCardMode(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductCards, { once: true });
  } else {
    initializeProductCards();
  }

  document.addEventListener('shopify:section:load', (event) => updateProductCardMode(event.target));
  if (typeof mobileProductCardQuery.addEventListener === 'function') {
    mobileProductCardQuery.addEventListener('change', initializeProductCards);
  } else {
    mobileProductCardQuery.addListener(initializeProductCards);
  }
})();
